import { Component, Injector, Input, OnInit } from '@angular/core';
import { take } from 'rxjs';
import { ObjectUtil } from '../../../../../components/common/object-util/object-util';
import { WidgetDynamicBaseComponent } from '../../widgetDynamicBase';

@Component({
  selector: 'lease-up-costs-widget',
  templateUrl: './lease-up-costs-widget.component.html',
  styleUrls: ['../../common/css/general.scss', './lease-up-costs-widget.component.scss']
})
export class LeaseUpCostsWidgetComponent extends WidgetDynamicBaseComponent implements OnInit {
  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useDefaultServiceSaveChangesHandler("leaseUpCosts", this.provideSaveObject.bind(this));
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    if (!this.widgetConfig.hashtagSupported) {
      this.widgetConfig.hashtagSupported = true;
    }
    this.mockupData$ = this.widgetService.loadMockup('leaseUpCosts').pipe(take(1));

    this.widgetData$ = this.mockup ?
      this.mockupData$
      : this.widgetService.load('leaseUpCosts', this.getReport()).pipe();
  }

  /**
   * Constructor
   * @param injector
   */
  constructor(injector: Injector) {
    super(injector, 'leaseUpCosts', false);
  }

  /**
 * Initializes the component
 */
  ngOnInit(): void {
    this.initWidgetConfig();
    this.widgetResized();
  }

  /**
   * Based on the amount of columns in the data, each widget can request to be put on a H page if it's alone on a V page
   * @returns true if it could need more columns
   */
  public moreColumnsRequestedIfOnPortraitPage(): boolean {
    return false;//This widget always fits
  }

  /**
   * Called by base class in save process. Widget should return object to be saved
   */
  async provideSaveObject(): Promise<any> {
    const data = ObjectUtil.deepCopy(this.widgetData);//deep copy

    return data;
  }

  /**
   * Called by base class to inform widget about save action result
   * @param _success {boolean} The result of save action
   * @param _err {any} The error object, if save action failed
   */
  saveCompleted(_success: boolean, _err: any = null): void {
    //do something if error
  }

  public getMinimumRowIndex(): number {
    return 1;
  }

  public getMaximumRowIndex(): number {
    if (this.widgetData) {
      return this.widgetData?.rows?.length + 13;
    }
    return -1;
  }
}
